import React from 'react';
import { withTrans } from '../i18n/withTrans';
import '../styles/app.scss';

const Layout = ({ children }) => {
	return (<div>{children}</div>);
};

export default withTrans(Layout);
